<div *ngIf="inputRes" class="d-flex">
  <div style="display: flex; margin-right: 15px; border-right: 4px solid #00070e;">
    <ng-container [ngSwitch]="inputRes.STATUS_TASK">
      <ng-container *ngSwitchCase="-2">
        <i-tabler name="square-check" class="icon-24 d-flex" style="align-items: center; margin: auto; margin-right: 15px; background: #ff4f4f; border-radius: 2px;"></i-tabler>
      </ng-container>
      <ng-container *ngSwitchCase="-1">
        <i-tabler name="square-check" class="icon-24 d-flex" style="align-items: center; margin: auto; margin-right: 15px; background: orange; border-radius: 2px;"></i-tabler>
      </ng-container>
      <ng-container *ngSwitchCase="0">
        <kendo-loader style="margin: auto;padding-right: 15px;" [type]="'pulsing'" [themeColor]="inputRes.IS_SYNCED ? 'warning' : 'primary'" [size]="'medium'" ></kendo-loader>
      </ng-container>
      <ng-container *ngSwitchCase="1">
        <kendo-loader style="margin: auto;padding-right: 15px;" [type]="'pulsing'" [themeColor]="inputRes.IS_SYNCED ? 'warning' : 'primary'" [size]="'medium'" ></kendo-loader>
      </ng-container>
      <ng-container *ngSwitchCase="2">
        <i-tabler name="square-check" class="icon-24 d-flex" style="align-items: center; margin: auto; margin-right: 15px; background: #24e324; border-radius: 2px;"></i-tabler>
      </ng-container>
    </ng-container>
    <span style="position: absolute; top: 0; left: 0; background: black; color: white; font-weight: 700; font-size: 12px; padding: 2px; padding-left: 8px; padding-right: 8px; border-bottom-right-radius: 4px;">{{ timeCountF }}</span>
  </div>
  <div style="margin-right: 15px;min-width: 350px;">
    <ng-container *ngIf="inputRes.IS_SYNCED">
      <div class="d-grid">
        <ng-container [ngSwitch]="inputRes.STATUS_TASK">
          <ng-container *ngSwitchCase="-2"><!-- ERREUR -->
            <span style="background-color: #ff4f4f; font-weight: 700; padding: 6px; border-radius: 8px;">
              <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">{{ STATUS_TASK_LABELS[inputRes.STATUS_TASK] }}</span>
              {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
            </span>
            <span style="margin-top: 12px; font-size: 13px;"> {{ inputRes.RESULT_JOB }} </span>
          </ng-container>
          <ng-container *ngSwitchCase="-1"><!-- ANNULE -->
            <span style="background-color: orange; font-weight: 700; padding: 6px; border-radius: 8px;">
              <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">{{ STATUS_TASK_LABELS[inputRes.STATUS_TASK] }}</span>
              {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
            </span>
            <span style="margin-top: 12px; font-size: 13px;"> {{ inputRes.RESULT_JOB }} </span>
          </ng-container>
          <ng-container *ngSwitchCase="0"><!--EN ATTENTE -->
            <span style="background-color: #4b93ff; font-weight: 700; padding: 6px; border-radius: 8px;">
              <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">{{ STATUS_TASK_LABELS[inputRes.STATUS_TASK] }}</span>
              {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
            </span>
            <span style="margin-top: 12px; font-size: 13px;"> {{ inputRes.RESULT_JOB }} </span>
          </ng-container>
          <ng-container *ngSwitchCase="1"><!--EN COURS -->
            <span style="background-color: gold; font-weight: 700; padding: 6px; border-radius: 8px;">
              <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">{{ STATUS_TASK_LABELS[inputRes.STATUS_TASK] }}</span>
              {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
            </span>
            <span style="margin-top: 12px; font-size: 13px;"> {{ inputRes.RESULT_JOB }} </span>
          </ng-container>
          <ng-container *ngSwitchCase="2"><!--EN COURS -->
            <span style="background-color: #24e324; font-weight: 700; padding: 6px; border-radius: 8px;">
              <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">{{ STATUS_TASK_LABELS[inputRes.STATUS_TASK] }}</span>
              {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
            </span>
            <span style="margin-top: 12px; font-size: 13px;"> {{ inputRes.RESULT_JOB }} </span>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="!inputRes.IS_SYNCED">
      <div class="d-grid" *ngIf="inputRes.STATUS_TASK != -1">
        <span style="background-color: #4c63ff; font-weight: 700; padding: 6px; border-radius: 8px;">
          <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">RUNNER</span>
          {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
        </span>
        <span style="margin-top: 12px; font-size: 13px;">En attente de récupération par le Runner..</span>
      </div>
      <div class="d-grid" *ngIf="inputRes.STATUS_TASK == -1">
        <span style="background-color: orange; font-weight: 700; padding: 6px; border-radius: 8px;">
          <span style="font-size: 8px; color: white; background: black; padding: 4px; margin-right: 4px; border-radius: 4px; vertical-align: middle;">RUNNER</span>
          {{ inputRes.LIBELLE_TASK }} <span>{{ inputRes.DATE_CREATION | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
        </span>
        <span style="margin-top: 12px; font-size: 13px;">Annulé avant récupération..</span>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="inputRes.IS_SYNCED">
    <ng-container *ngIf="[0,1].indexOf(inputRes.STATUS_TASK) > - 1">
      <button kendoButton fillMode="outline" (click)="doGetRunnerTaskProgressAction_ZBEQuickActionsSyncSage()" style="font-weight: 700; height: 34px; margin: auto; background-color: #042f5f !important; color: white; font-size: 11px;">
        ACTUALISER
      </button>
    </ng-container>
    <ng-container *ngIf="[-2,-1,2].indexOf(inputRes.STATUS_TASK) > - 1">
      <button kendoButton fillMode="outline" (click)="ignoreNotification($event)" style="font-weight: 700; height: 34px; margin: auto; background-color: #000000 !important; color: white; font-size: 11px;">
        FERMER
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!inputRes.IS_SYNCED">
    <button *ngIf="inputRes.STATUS_TASK != -1" kendoButton fillMode="outline" (click)="doCancelRunnerTasksAction_ZBEQuickActionsSyncSage()" style="font-weight: 700; height: 34px; margin: auto; background-color: #5f0404 !important; color: white; font-size: 11px;">
      ANNULER
    </button>
    <button *ngIf="inputRes.STATUS_TASK == -1" kendoButton fillMode="outline" (click)="ignoreNotification($event)" style="font-weight: 700; height: 34px; margin: auto; background-color: #000000 !important; color: white; font-size: 11px;">
      FERMER
    </button>
  </ng-container>
</div>
